<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
      <v-icon>mdi-compass</v-icon><span class="font-weight-bold">O'game</span>
      </div>
<v-spacer/>
<v-menu
    v-model="menu3"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  ><template v-slot:activator="{ on }">
<v-btn v-on="on" icon><v-icon>mdi-map-plus</v-icon></v-btn>
</template>
<v-card>

  <v-card-text>
    <p class="subtitle-2">{{ $t('add_map_explain')}}</p>
    <v-btn color="primary" href="mailto:simon.blum@hotmail.fr?subject=Contact%20OGame"><v-icon>mdi-mail</v-icon> {{ $t('contact_me') }}</v-btn>
  </v-card-text></v-card>
</v-menu>

<v-btn :to="{name:'Map'}" icon><v-icon>mdi-map-search</v-icon></v-btn>

<v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
  <template v-slot:activator="{ on }">
<v-btn v-on="on" icon><v-icon>mdi-cogs</v-icon></v-btn>
 </template>
 <v-card>
   <v-card-title>
     {{ $t('settings') }}
   </v-card-title>
   <v-card-text>
 <v-form>
    <v-select
    v-model="lang"
           :items="items"
           item-text="text"
           item-value="value"
           :label="$t('language')"
           outlined
         ></v-select>
         <v-btn @click="clean_cache">{{ $t('clean_cache') }}</v-btn>
  </v-form>
   </v-card-text>
 </v-card>
</v-menu>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

  </v-app>
</template>

<script>

export default {
  name: 'App',

  watch: {
    lang(v) {
      this.$i18n.locale = v;
    },
    m: function(v, old_v) {
        if (v !== old_v) {
          this.$router.push({name: 'Home', params: {place: v}});
        }
    }
  },
  methods: {
    clean_cache() {
      window.location.reload();
    }
  },
  mounted() {

    this.lang = this.$i18n.locale;

  },
  data: () => ({
    m: '',
    lang: '',
    items: [{text: 'Français', value:'fr'}, {text: 'English', value: 'en'}, {text: 'Hungarian', value: 'hu'}],
    menu: false,
    menu3: false,
    menu2: false,
  }),
};
</script>
